module.exports = __webpack_public_path__ + "assets/ee9b717575edd9dded608b9a92ab88e7.png";